<!-- ✅ Version update banner -->
@if (versionCheckService?.newVersionAvailable) {
  <div class="version-banner">
    A new version is available.
    <a href="#" (click)="versionCheckService.forceHardReloadPreservingKeys($event)">Click here</a> to update.
  </div>
}
@if (applicationTheme && tacApproved) {
  <div class="h-100" [zenTheme]="applicationTheme">
    <router-outlet></router-outlet>
  </div>
}

<div id="zen-guided-tour">
  <ngx-guided-tour skipText="End Tour" backText="Previous" [topOfPageAdjustment]="25"></ngx-guided-tour>
</div>
